import "./style.scss";
import ActivityCard from "@components/ActivityCard";
import PagesHeader from "@components/PagesHeader";
import { useQuery } from "@tanstack/react-query";
import { getActivationList } from "../../api/activation";
import {
  DETAILS_CACHE_TIME,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "../../api/consumer";
import cardPlaceholderImage from "@assets/awards/card-placeholder.jpg";
import AwardCardPlaceholder from "@components/AwardCardPlaceholder";
import ActivityCardPlaceholder from "@components/ActivityCardPlaceholder";
import { useEffect, useState } from "react";
import spider from "../Activities/Activities/Idents/quiz_7/img/spider.svg";
import Object from "@components/FindGame";
import { EasterEgg } from "@pages/EasterEggPage";
import { filterDjConsoleActivations, canAccessQrScanner } from "../../Helpers";

export default function Activities() {
  const { data } = useQuery({
    queryKey: ["activation-list"],
    queryFn: getActivationList,
  });
  const { data: userData } = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const registerSource = userData?.consumer?.registerSource;
  const activations = filterDjConsoleActivations(
    data?.activations,
    registerSource,
  );

  const someCompleted = activations?.some((quiz) => quiz.completed);
  const toCompleted = activations?.filter((quiz) => !quiz.completed);
  const completed = activations?.filter((quiz) => quiz.completed);

  useEffect(() => {
    dataLayer.push({
      event: "view_activation_list",
      ...data,
    });
  }, [data]);

  return (
    <section className="activities">
      <PagesHeader>
        <strong>Punkte sammeln</strong>
      </PagesHeader>

      {/* <Object
        bottom="object-3"
        uuid={"0ee97f02-ba45-461f-af80-1e4908f05cb3"}
        image={spider}
        innerImage={spider}
        copy={`<p style="font-size:20px"><strong >Glückwunsch!</strong></p><br/>Du hast eine Spinne gefangen!`}
      /> */}
      <div className="grid">
        {/* <EasterEgg ident={"halloween2025_1"} direction="left" /> */}
        {toCompleted?.map((activation, index) => (
          <ActivityCard
            key={index}
            mobileImg={activation?.thumbnail?.file?.url}
            desktopImg={activation?.hero_image?.file?.url}
            imgDesc={activation?.hero_image?.metadata?.imgDesc}
            copy={activation?.content?.description}
            points={activation.payout}
            brands={activation.brands}
            completed={activation.completed}
            ident={activation.ident}
            type={activation.type}
            highlighted={activation.highlighted}
            hidePoints={
              activation.ident === "advent_2023_0"
                ? true
                : activation.ident === "challenge_styczen_2024"
                  ? true
                  : activation.completed
                    ? true
                    : false
            }
          />
        ))}

        {completed?.map((activation, index) => (
          <ActivityCard
            key={index}
            mobileImg={activation?.thumbnail?.file?.url}
            desktopImg={activation?.hero_image?.file?.url}
            imgDesc={activation?.hero_image?.metadata?.imgDesc}
            copy={activation?.content?.description}
            points={activation.payout}
            brands={activation.brands}
            completed={activation.completed}
            ident={activation.ident}
            type={activation.type}
            highlighted={activation.highlighted}
            hidePoints={
              activation.ident === "advent_2023_0"
                ? true
                : activation.ident === "challenge_styczen_2024"
                  ? true
                  : activation.completed
                    ? true
                    : false
            }
          />
        ))}

        {userData && canAccessQrScanner(userData?.consumer?.brands) && (
          <ActivityCardPlaceholder variant="qr" />
        )}

        {someCompleted && (
          <AwardCardPlaceholder
            href01="/invite"
            href02={`${import.meta.env.VITE_DG_URL}/glo_device/customer/index/`}
            img={cardPlaceholderImage}
            topCopy01={"LUST AUF MEHR PUNKTE?"}
            topCopy02={"NOCH MEHR PUNKTE"}
            bottomCopy01={`<strong>Lade </strong>deine
                <br /> Freunde ein`}
            bottomCopy02={`<strong>Registriere</strong>
                <br /> glo™`}
            activity
            brands={userData?.consumer.brands}
          />
        )}
        {!someCompleted && (
          <ActivityCardPlaceholder brands={userData?.consumer.brands} />
        )}
      </div>
    </section>
  );
}
